import type { Home } from '@lmc/ts-common'
import { NavigationModal } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

type ReactivatingServiceUserModalProps = {
  showModal: boolean
  onCancel: () => void
  onConfirm: () => void
  backNavigation: () => void
  name: string
}

const ReactivatingServiceUserModal = ({
  showModal,
  onCancel,
  onConfirm,
  backNavigation,
  name
}: ReactivatingServiceUserModalProps) => {
  const { t } = useTranslation()

  const preferredPeopleNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative
  )

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <NavigationModal
      modalTitle={t('REACTIVATE_SU_TITLE')}
      modalContentText={t('REACTIVATE_SU_DESCRIPTION', {
        name,
        nominative: preferredPeopleNominative
      })}
      modalConfirmText={t('OK')}
      modalCancelText={t('CANCEL')}
      showPrompt={showModal}
      confirmNavigation={handleConfirm}
      cancelNavigation={onCancel}
      confirmButtonProps={{ variant: 'primary' }}
      hasBackButton
      backButtonText={t('BACK')}
      backNavigation={backNavigation}
    >
      <Container />
    </NavigationModal>
  )
}

const Container = styled.div`
  height: 140px;
`

export default ReactivatingServiceUserModal
